var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9787 21.8672L22.992 18.4139C22.6418 18.1718 22.2321 18.0302 21.8072 18.0043C21.3823 17.9784 20.9584 18.0693 20.5814 18.2671C20.2044 18.4648 19.8887 18.7619 19.6685 19.1262C19.4483 19.4905 19.3319 19.9082 19.332 20.3339V27.2405C19.3319 27.6662 19.4483 28.0838 19.6685 28.4481C19.8887 28.8124 20.2044 29.1096 20.5814 29.3073C20.9584 29.5051 21.3823 29.5959 21.8072 29.5701C22.2321 29.5442 22.6418 29.4026 22.992 29.1605L27.9787 25.7072C28.2895 25.4926 28.5435 25.2057 28.719 24.8713C28.8944 24.5369 28.9861 24.1649 28.9861 23.7872C28.9861 23.4095 28.8944 23.0375 28.719 22.7031C28.5435 22.3686 28.2895 22.0818 27.9787 21.8672V21.8672Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay4);
export default __webpack_public_path__ + "static/media/play4.465d634e9fbb2c5596f7be1cd30fab9e.svg";
export { ForwardRef as ReactComponent };